import { defaultThClass } from '../../kompack/config'

// eslint-disable-next-line import/prefer-default-export
export const ARTIKEL_CONFIG = {
  text: {
    searchPlaceholder: 'Search...',
    btnAdd: 'Artikel Baru',
    emptyState: 'Tidak ada data artikel untuk ditampilkan',
  },
  statusOptions: [
    { text: 'Default', value: null },
    { text: 'Publish', value: 'publish' },
    { text: 'Draft', value: 'draft' },
    { text: 'Hide', value: 'hide' },
  ],
  headers: [
    {
      key: 'checkbox', label: '', class: 'w-[50px] pl-[0.75rem]', tdClass: 'w-[50px] p-0 ml-[0.75rem] border-[0px]',
    },
    {
      key: 'title', label: 'Judul Artikel', class: 'flex-1 px-[0.75rem]', tdClass: 'min-w-[230px] flex-1 !py-0 !px-[0.75rem] border-[0px] text-[14px] text-[#0A0A0A] font-medium whitespace-pre-wrap [overflow-wrap:anywhere]', tdAttr: { style: 'white-space: pre-wrap; overflow-wrap: anywhere;' },
    },
    {
      key: 'status', label: 'Status', class: 'w-[150px] text-center px-[0.75rem]', tdClass: 'w-[150px] text-center !px-[0.75rem] !py-[0px] border-[0px]',
    },
    {
      key: 'view_count',
      label: 'Pengunjung',
      class: 'w-[120px] px-[0.75rem]',
      tdClass: 'w-[120px] !px-[0.75rem] !py-[0px] border-[0px] text-[14px] text-[#0A0A0A]',
      formatter: value => (value ? new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1, roundingMode: 'floor' }).format(value) : '0'),
    },
    {
      key: 'updated_at', label: 'Pembaruan Terakhir', class: 'w-[310px] px-[0.75rem]', tdClass: 'w-[310px] !px-[0.75rem] !py-[0px] border-[0px]',
    },
  ],
}

export const TAB_LIST = [
  {
    title: 'Artikel',
    value: 'article',
  },
  {
    title: 'Kategori',
    value: 'category',
  },
]

const thStyle = {
  textTransform: 'capitalize',
  fontSize: '14px',
  color: '#222222',
  background: '#F4F4F4',
  fontWeight: '500',
  borderBottom: '0',
  padding: '12px 16px',
}
const tdClass = 'align-middle !px-[12px]'

export const CATEGORY_TABLE_FIELDS = [
  {
    key: 'name',
    label: 'Nama Kategori',
    thStyle: {
      ...thStyle,
      minWidth: '300px',
    },
    tdClass,
  },
  {
    key: 'article_count',
    label: 'Jumlah Artikel',
    thStyle: {
      ...thStyle,
      minWidth: '200px',
    },
    tdClass,
  },
  {
    key: 'action',
    label: 'Aksi',
    thStyle: {
      ...thStyle,
      width: '200px',
    },
    tdClass,
  },
]

export const DEFAULT_CATEGORY_NAME = 'Tanpa Kategori'
export const MAX_TOTAL_CATEGORY = 15
